import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: [],
}

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    addFilterData: (state,action) => {
      state.filters = action.payload;
    },
    
  },
})

// Action creators are generated for each case reducer function
export const { addFilterData } = filterSlice.actions

export default filterSlice.reducer